import script from "./Top.vue?vue&type=script&lang=ts&setup=true"
export * from "./Top.vue?vue&type=script&lang=ts&setup=true"

import "./Top.vue?vue&type=style&index=0&id=1e287598&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e287598"]])

export default __exports__